export function filterAdditionalProducts(additionalProducts = []) {
  const filteredAdditionalProducts = []

  const serviceAgreement = additionalProducts?.find(
    (ap) => agreementCodeMapper(ap?.AgreementCode) === 'service',
  )
  if (serviceAgreement) {
    filteredAdditionalProducts.push(serviceAgreement)
  }

  const tireStorageAgreement = additionalProducts?.find(
    (ap) => agreementCodeMapper(ap?.AgreementCode) === 'tireStorage',
  )
  if (tireStorageAgreement) {
    filteredAdditionalProducts.push(tireStorageAgreement)
  }

  const serviceAndMaintenanceAgreement = additionalProducts?.find(
    (ap) => agreementCodeMapper(ap?.AgreementCode) === 'serviceAndMaintenance',
  )
  if (serviceAndMaintenanceAgreement) {
    filteredAdditionalProducts.push(serviceAndMaintenanceAgreement)
  }

  return filteredAdditionalProducts
}

export function mapAdditionalProductName(type: string) {
  switch (type) {
    case 'service': {
      return 'Serviceavtale'
    }
    case 'tireStorage': {
      return 'Dekkhotell'
    }
    case 'fuel': {
      return 'Drivstoff- og ladekort'
    }
    case 'serviceAndMaintenance': {
      return 'Service- og vedlikeholdsavtale'
    }
    default: {
      return 'Ukjent tilleggstjeneste'
    }
  }
}

export function agreementCodeMapper(agreementCode: string) {
  const tireStorageList = ['DEKKHOTELL', 'DEKKHOTEL']
  const tollList = ['BOMPENGER', 'BOMPENGERKORT', 'SKYT_BOMP']
  const fuelList = [
    /*   'FUELCARD',
    'FUELCARDKORT',
    'D_STATOIL',
    'D_SHELL',
    'D_ESSO',
    'D_YX',
    'L_MER',
    'L_KOPLE',
    'L_FORTUM', */
  ]
  const parkList = [
    'PARKERING',
    'PARKERINGKORT',
    'PARKER',
    'EASYPARK',
    'ANPR PARK',
    'PARLINK',
  ]
  const workshopList = ['VERKSTED', 'VERKSTEDKORT']
  const serviceList = ['SERVICE', 'SERVICEKORT', 'SERVICEAVT']
  const insuranceList = ['KASKO', 'TRYGFORS', 'IF', 'TRYG TFA']
  const serviceAndMaintenanceList = ['SV AVT']
  if (tireStorageList.includes(agreementCode)) {
    return 'tireStorage'
  }
  if (tollList.includes(agreementCode)) {
    return 'toll'
  }
  if (fuelList.includes(agreementCode)) {
    return 'fuel'
  }
  if (parkList.includes(agreementCode)) {
    return 'park'
  }
  if (workshopList.includes(agreementCode)) {
    return 'workshop'
  }
  if (serviceList.includes(agreementCode)) {
    return 'service'
  }
  if (insuranceList.includes(agreementCode)) {
    return 'insurance'
  }
  if (serviceAndMaintenanceList.includes(agreementCode)) {
    return 'serviceAndMaintenance'
  }
  return null
}
